// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake"}[chunkId] + "." + {"102":"ff20c18c","133":"df135181"}[chunkId] + ".chunk.js";
};